import { type CountryCode } from '@hublo/enums'

export interface WorkerInstitutions {
  id: number
  type: number
  uuid: string
  isEnabled: boolean
}

export interface WorkerProfile {
  id: number
  email: string
  firstName: string
  lastName: string
  searchName?: string
  phone: string
  isEmailConfirmed?: boolean
  stateOnboarding: number
  isEmailNotificationOn: boolean
  isPoolEligible: boolean
  isWhatsappOn: boolean
  birthplace?: string
  socialSecurityNumber?: string
  nationality?: string
  birthday?: string
  birthDepartment?: string
  tokenValidationNumber: number
  institutions?: WorkerInstitutions[]
  pictureUrl?: string
  postalCode?: string
  address?: string
  lat?: number
  lng?: number
  idLanguage?: number
  timezone?: string
  hubloId?: string
  createdAt: string
  rpps?: string
  professionalStatus?: 'EMPLOYEE' | 'VACATAIRE' | 'STUDENT'
  openToWork?: boolean
  country: CountryCode
}
export interface WorkerProfileAsAdmin {
  id: number
  email: string
  firstName: string
  lastName: string
  phone: string
  institutions: {
    idInstitution: number
    name: string
    type: number
  }[]
  pictures?: { url: string }[]
}

export const isWorkerInSignup = (worker?: WorkerProfile): boolean =>
  Boolean(worker)

export const MINIMUM_AGE_REQUIRED = 16
